/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Team_Solo_ThreeInputs */

const en_platform_team_solo_three = /** @type {(inputs: Platform_Team_Solo_ThreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plans, diet and passes in one place`)
};

const pl_platform_team_solo_three = /** @type {(inputs: Platform_Team_Solo_ThreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plany, dieta i karnety w jednym miejscu`)
};

/**
* | output |
* | --- |
* | "Plans, diet and passes in one place" |
*
* @param {Platform_Team_Solo_ThreeInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_team_solo_three = /** @type {((inputs?: Platform_Team_Solo_ThreeInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Team_Solo_ThreeInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_team_solo_three(inputs)
	return en_platform_team_solo_three(inputs)
});